import { useLocation, Link } from 'react-router-dom';
import { Home, Crosshair, Clock, User } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useCallStateSafe } from '@/context/CallStateContext';

const navItems = [
  { path: '/my-dashboard', label: 'Home', icon: Home, match: ['/my-dashboard'] },
  { path: '/practice', label: 'Practice', icon: Crosshair, match: ['/practice', '/train'] },
  { path: '/sessions', label: 'Sessions', icon: Clock, match: ['/sessions'] },
  { path: '/me', label: 'Profile', icon: User, match: ['/me'] },
];

const hiddenRoutes = ['/', '/product', '/solutions', '/resources', '/pricing', '/contact', '/privacy', '/terms', '/auth', '/onboarding', '/choose-plan', '/subscription-success', '/subscription-cancel', '/accept-invite', '/setup-dealership'];

export function BottomNav() {
  const location = useLocation();
  const callState = useCallStateSafe();

  const isHiddenRoute = hiddenRoutes.some(route => location.pathname === route) ||
    location.pathname.startsWith('/auth') ||
    location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/global-admin');

  if (callState?.isCallActive || isHiddenRoute) return null;

  return (
    <nav
      aria-label="Primary"
      className="fixed bottom-0 left-0 right-0 z-50 block md:hidden bg-background/95 backdrop-blur-md border-t border-border"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map(({ path, label, icon: Icon, match }) => {
          const isActive = match.some(prefix => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`));
          return (
            <Link
              key={path}
              to={path}
              aria-current={isActive ? 'page' : undefined}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 flex-1 min-h-[48px] min-w-[48px] py-1.5 transition-all touch-manipulation active:scale-95",
                isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
              )}
            >
              <span
                className={cn(
                  "flex items-center justify-center rounded-full transition-all",
                  isActive
                    ? "bg-primary/12 px-5 py-1.5"
                    : "px-2 py-1.5"
                )}
              >
                <Icon className={cn("h-5 w-5", isActive && "drop-shadow-[0_0_6px_hsl(var(--primary)/0.45)]")} />
              </span>
              <span className="text-[11px] font-medium leading-none">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
